
const validateLogin = (data) =>{
    let errors = {
        isValidated : true
    }

    if(!data.Username){
        errors.username = "Username is required";
        errors.isValidated = false;
    }
     if(!data.Password){
        errors.password = "Password is required";
        errors.isValidated = false;
    }
    return errors;
}

export default validateLogin;